module.exports = __webpack_public_path__ + "static/media/prize.b0a43d02.svg";